import { LoadingButton } from "@mui/lab";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Fragment, useState } from "react";
import { ConfirmOptions } from "./ConfirmProvider";

export interface ConfirmationDialogProps extends ConfirmationDialogBaseProps {
  options: ConfirmOptions;
}

export interface ConfirmationDialogBaseProps {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onClose?: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void;
}

export const ConfirmationDialog = ({
  open,
  options,
  loading,
  onCancel,
  onConfirm,
  onClose,
}: ConfirmationDialogProps) => {
  const {
    title,
    description,
    content,
    confirmationText,
    cancellationText,
    dialogProps,
    confirmationButtonProps,
    cancellationButtonProps,
    titleProps,
    contentProps,
    allowClose,
    actionBuilder,
  } = options;

  return (
    <Dialog fullWidth {...dialogProps} open={open} onClose={allowClose ? onClose : undefined}>
      {title && <DialogTitle {...titleProps}>{title}</DialogTitle>}
      {content ? (
        <DialogContent {...contentProps}>{content}</DialogContent>
      ) : (
        description && (
          <DialogContent {...contentProps}>
            <DialogContentText>{description}</DialogContentText>
          </DialogContent>
        )
      )}
      <DialogActions>
        {actionBuilder ? (
          actionBuilder(onConfirm, onCancel, loading, options)
        ) : (
          <Fragment>
            <Button
              {...cancellationButtonProps}
              onClick={onCancel}
              {...(options.isAsynchronous ? { disabled: loading } : undefined)}
            >
              {cancellationText}
            </Button>
            {options.isAsynchronous ? (
              <LoadingButton color="primary" {...confirmationButtonProps} loading={loading} onClick={onConfirm}>
                {confirmationText}
              </LoadingButton>
            ) : (
              <Button color="primary" {...confirmationButtonProps} onClick={onConfirm}>
                {confirmationText}
              </Button>
            )}
          </Fragment>
        )}
      </DialogActions>
    </Dialog>
  );
};
